import { render, staticRenderFns } from "./NumbersComponent.vue?vue&type=template&id=ae0b656a"
import script from "./NumbersComponent.vue?vue&type=script&lang=js"
export * from "./NumbersComponent.vue?vue&type=script&lang=js"
import style0 from "./NumbersComponent.vue?vue&type=style&index=0&id=ae0b656a&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports